"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickbooksMonth = void 0;
var QuickbooksMonth;
(function (QuickbooksMonth) {
    QuickbooksMonth["Jan"] = "Jan";
    QuickbooksMonth["Feb"] = "Feb";
    QuickbooksMonth["Mar"] = "Mar";
    QuickbooksMonth["Apr"] = "Apr";
    QuickbooksMonth["May"] = "May";
    QuickbooksMonth["Jun"] = "Jun";
    QuickbooksMonth["Jul"] = "Jul";
    QuickbooksMonth["Aug"] = "Aug";
    QuickbooksMonth["Sep"] = "Sep";
    QuickbooksMonth["Oct"] = "Oct";
    QuickbooksMonth["Nov"] = "Nov";
    QuickbooksMonth["Dec"] = "Dec";
})(QuickbooksMonth || (exports.QuickbooksMonth = QuickbooksMonth = {}));
